/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Preparing_AudioInputs */

const en_kindle_preparing_audio = /** @type {(inputs: Kindle_Preparing_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing audio…`)
};

const es_kindle_preparing_audio = /** @type {(inputs: Kindle_Preparing_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando audio…`)
};

/**
* | output |
* | --- |
* | "Preparing audio…" |
*
* @param {Kindle_Preparing_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_preparing_audio = /** @type {((inputs?: Kindle_Preparing_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Preparing_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_preparing_audio(inputs)
	return en_kindle_preparing_audio(inputs)
});